import FooterC1Links from '../FooterC1Links';
import FooterC1Share from '../FooterC1Share';
import './index.scss';

export default function FooterC1({ locale, TextA = {}, theme = 'black' }: { locale: string; TextA: any; theme: 'white' | 'black' | 'gray' }) {
    return (
        <div className={`footer-FooterC1 footer-FooterC1-theme-${theme}`}>
            <FooterC1Links locale={locale} TextA={TextA} theme={theme} />
            <div className="footer-FooterC1-shares">
                <p className="footer-FooterC1-copywrite">{TextA.copywrite}</p>
                <FooterC1Share locale={locale} theme={theme} />
            </div>
        </div>
    );
}
